import React from 'react';

interface BrandVoiceProps {
  tone?: string[];
  personality?: string;
  dosList?: string[];
  dontsList?: string[];
}

export function BrandVoice({ tone, personality, dosList, dontsList }: BrandVoiceProps) {
  const hasContent = tone?.length || personality || dosList?.length || dontsList?.length;

  if (!hasContent) {
    return null;
  }

  return (
    <div className="py-6 border-b border-border">
      <h3 className="text-sm font-semibold text-foreground mb-4">Brand Voice</h3>

      {/* Tone Pills */}
      {tone && tone.length > 0 && (
        <div className="mb-4">
          <div className="text-xs text-muted-foreground mb-2">Tone</div>
          <div className="flex flex-wrap gap-2">
            {tone.map((item, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Personality */}
      {personality && (
        <div className="mb-4">
          <div className="text-xs text-muted-foreground mb-2">Personality</div>
          <p className="text-sm text-foreground leading-relaxed">
            {personality}
          </p>
        </div>
      )}

      {/* Do's and Don'ts */}
      {((dosList && dosList.length > 0) || (dontsList && dontsList.length > 0)) && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Do's */}
          {dosList && dosList.length > 0 && (
            <div>
              <div className="text-xs font-semibold text-green-600 dark:text-green-400 mb-2 flex items-center gap-1">
                <span>✓</span>
                <span>Do's</span>
              </div>
              <ul className="space-y-1.5">
                {dosList.map((item, index) => (
                  <li key={index} className="text-sm text-foreground flex items-start gap-2">
                    <span className="text-green-600 dark:text-green-400 mt-0.5">•</span>
                    <span className="flex-1">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Don'ts */}
          {dontsList && dontsList.length > 0 && (
            <div>
              <div className="text-xs font-semibold text-red-600 dark:text-red-400 mb-2 flex items-center gap-1">
                <span>✗</span>
                <span>Don'ts</span>
              </div>
              <ul className="space-y-1.5">
                {dontsList.map((item, index) => (
                  <li key={index} className="text-sm text-foreground flex items-start gap-2">
                    <span className="text-red-600 dark:text-red-400 mt-0.5">•</span>
                    <span className="flex-1">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
